import React from 'react';
import querystring from 'query-string';
import {Col, Container, Row} from 'reactstrap';
import fetch from './fetch';

class BrushlinkAuth extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null
        };
    }

    componentDidMount() {
        const query = querystring.parse(window.location.search.substring(1));
        if (query.error) {
            let redirect;
            switch (query.error) {
                case 'login_required':
                case 'interaction_required':
                    redirect = window.sessionStorage.getItem('brush_brushlink_authorize_url');
                    break;
                default:
                    break;
            }
            if (redirect) {
                window.location = redirect;
            } else {
                this.setState({
                    error: query.error_description
                });
            }
            return;
        } else {
            window.sessionStorage.removeItem('brush_brushlink_authorize_url');
        }

        const state = window.sessionStorage.getItem('brush_brushlink_state');
        window.sessionStorage.removeItem('brush_brushlink_state');

        // Section removed as per https://ddxdental.atlassian.net/browse/SB-67
        // if (query.state !== state) {
        //     this.setState({
        //         error: 'Invalid state'
        //     });
        //     return;
        // }

        // api request to backed with code
        let params = {
            code: query.code
        };

        fetch('/api/v1/brushlink-token?' + querystring.stringify(params), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).finally((resp) => {
            if (!this.state.error) {
                //browserHistory.replace(query.redirect_uri ? query.redirect_uri : '/providers');
                if (window.opener) {
                    window.opener.location.reload();
                    // window.close(); // https://ddxdental.atlassian.net/browse/SB-67
                }
            }
        });

    }

    render() {
        if (!this.state.error) {
            return (
                <div>
                    <h2>
                        Successfully paired with Brushlink! You can now close this window and access patient data from
                        inside the DDX Smartbrush Addon
                    </h2>
                </div>
            );
        }

        return (
            <Container>
                <Row>
                    <Col>
                        <h1>Authentication Error</h1>
                        <p>There was a problem authenticating with Brushlink. The following message was returned from
                            the server:</p>
                        <blockquote>{this.state.error}</blockquote>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default BrushlinkAuth;